import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

// Conteúdo jurídico provisório — REVISAR com advogado antes do go-live.
const TERMS = `
**Termos de Uso — La petite table**

1. Aceitação. Ao usar o La petite table, o estabelecimento concorda com estes termos.
2. Serviço. Oferecemos software de gestão (fila, comanda, cardápio, cozinha, fidelidade e analytics) em modelo de assinatura.
3. Conta e assinatura. O acesso depende de assinatura ativa, após período de teste de 7 dias com cartão. O cancelamento encerra o acesso ao fim do ciclo vigente.
4. Uso aceitável. O cliente é responsável pelos dados que insere e pelo uso conforme a legislação aplicável.
5. Disponibilidade. Empregamos esforços razoáveis para manter o serviço no ar, sem garantia de ininterrupção.
6. Limitação de responsabilidade. O serviço é fornecido "no estado em que se encontra".
7. Alterações. Estes termos podem ser atualizados; mudanças relevantes serão comunicadas.
`;

const PRIVACY = `
**Política de Privacidade — La petite table**

1. Dados que tratamos. Dados do estabelecimento (cadastro, equipe) e dados de clientes finais (nome, telefone e histórico de consumo/visitas), conforme inseridos no uso do sistema.
2. Finalidade. Operar o serviço, gerar relatórios e habilitar fidelidade e analytics.
3. Base legal (LGPD). Execução de contrato e legítimo interesse; consentimento quando aplicável.
4. Compartilhamento. Dados de inteligência de mercado só são compartilhados de forma **anonimizada** e mediante opt-in, com k-anonimato (mínimo de 3 estabelecimentos por recorte).
5. Direitos do titular. Você pode exportar ou apagar seus dados pessoais a qualquer momento na área de configurações.
6. Segurança. Empregamos isolamento por tenant (RLS), controle de acesso e boas práticas.
7. Contato. Para questões de privacidade, fale com o responsável pelo estabelecimento ou com o suporte.
`;

export function LegalPage({ kind }: { kind: 'terms' | 'privacy' }) {
  const { t } = useTranslation();
  const text = kind === 'terms' ? TERMS : PRIVACY;
  return (
    <div className="diner">
      <header className="diner__header">
        <Link className="brand" to="/">
          <span className="brand__name">La <em>petite</em> <span className="brand__accent">table</span></span>
        </Link>
      </header>
      <main className="diner__main legal">
        <h1 className="page__title">{kind === 'terms' ? t('legal.terms') : t('legal.privacy')}</h1>
        {text.trim().split('\n').filter(Boolean).map((line, i) => (
          <p key={i} className={line.startsWith('**') ? 'legal__h' : ''}>
            {line.replace(/\*\*/g, '')}
          </p>
        ))}
        <p className="muted-note">— {t('app.name')}</p>
      </main>
    </div>
  );
}
